import React from 'react';

const variants = {
  primary: { bg: '#EEF2FF', color: '#4A6CF7' },
  osg: { bg: '#FFF0F0', color: '#FF6B6B' },
  display: { bg: '#FFFBEB', color: '#B45309' },
  success: { bg: '#F0FFF4', color: '#34C759' },
  warning: { bg: '#FFF7ED', color: '#FF9500' },
  error: { bg: '#FFF0F0', color: '#FF3B30' },
  gray: { bg: '#F3F4F6', color: '#6B7280' },
  online: { bg: '#F0FFF4', color: '#34C759' },
  offline: { bg: '#F3F4F6', color: '#6B7280' },
  vacation: { bg: '#FFFBEB', color: '#FF9500' },
  urgent: { bg: '#FFF0F0', color: '#FF3B30' },
  normal: { bg: '#F3F4F6', color: '#6B7280' },
  pending: { bg: '#F3F4F6', color: '#6B7280' },
  in_progress: { bg: '#EEF2FF', color: '#4A6CF7' },
  completed: { bg: '#F0FFF4', color: '#34C759' },
  cancelled: { bg: '#FFF0F0', color: '#FF3B30' },
  active: { bg: '#F0FFF4', color: '#34C759' },
  inactive: { bg: '#F3F4F6', color: '#6B7280' },
  expired: { bg: '#FFF0F0', color: '#FF3B30' },
  critical: { bg: '#FFF3E0', color: '#FF9500' },
  ok: { bg: '#F0FFF4', color: '#34C759' },
  confirmed: { bg: '#F0FFF4', color: '#34C759' },
  corrected: { bg: '#EEF2FF', color: '#4A6CF7' },
};

export default function Badge({ variant = 'gray', children, style }) {
  const v = variants[variant] || variants.gray;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '2px 8px', borderRadius: 99,
      fontSize: 11, fontWeight: 600, letterSpacing: '0.02em',
      background: v.bg, color: v.color, whiteSpace: 'nowrap',
      ...style
    }}>
      {children}
    </span>
  );
}
